export default (win) => {
  let env = {};
  if (win && win.ENV) {
    env = win.ENV;
  }
  return env;
};
